export default () => ({
  // Simple state management
  resizeMode: false,
  buttonHeight: 0,
  buttonOpacity: 1,

  // Alpine.js lifecycle
  init() {
    // Set initial resize mode based on window width
    this.resizeMode = window.innerWidth < 1024;

    // Initial button position update
    this.updateButtonPosition();

    // Update button height
    this.updateButtonHeight();

    // Add event listeners
    window.addEventListener("resize", () => this.handleResize());
    window.addEventListener("scroll", () => this.updateButtonOpacity(), {
      passive: true,
    });
  },

  // Alpine.js computed property for button style
  get buttonStyle() {
    return `opacity: ${this.buttonOpacity}; transition: opacity 0.3s ease-in-out;`;
  },

  handleResize() {
    const newResizeMode = window.innerWidth < 1024;

    if (newResizeMode !== this.resizeMode) {
      this.resizeMode = newResizeMode;
      this.updateButtonPosition();
    }

    // Update height on resize
    this.updateButtonHeight();
  },

  updateButtonOpacity() {
    if (this.resizeMode) {
      const wrapper = document.getElementById("product-content-wrapper");
      const button = this.$el;

      if (wrapper && button) {
        const wrapperRect = wrapper.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();

        // Check if button has reached or passed the bottom of the wrapper
        const hasReachedBottom = buttonRect.top >= wrapperRect.bottom;

        // Binary state: either fully visible (1) or fully hidden (0)
        this.buttonOpacity = hasReachedBottom ? 0 : 1;
      }
    }
  },

  updateButtonPosition() {
    const button = this.$el;
    const container = document.getElementById(
      `product-content-${this.sectionId}`
    );
    const upper = document.getElementById("upper-buttons");
    const lower = document.getElementById("lower-buttons");

    if (!container || !upper || !lower) return;

    if (this.resizeMode) {
      // Move button to lower section on mobile
      if (button.parentNode !== lower) {
        lower.appendChild(button);
      }
    } else {
      // Move button back to container above upper buttons on desktop
      if (button.parentNode !== container) {
        container.insertBefore(button, upper);
      }
      // Reset opacity for desktop
      this.buttonOpacity = 1;
    }
  },

  updateButtonHeight() {
    this.$nextTick(() => {
      this.buttonHeight = this.$el.offsetHeight;

      // Update CSS variable
      document.documentElement.style.setProperty(
        "--pdp-buy-button-height",
        `${this.buttonHeight}px`
      );
    });
  },

  // Cleanup function for Alpine.js
  destroy() {
    // Alpine.js handles most cleanup automatically
  },
});
